export const fonts = {
  body: `Manrope, sans-serif`,
  heading: `Roc Grotesk, sans-serif`
};
